'use client'

import { useClampToggle } from '@/hooks/use-clamp-toggle'
import s from './expandable-text-component.module.scss'
import { ClampButton } from '@/components/v3/atoms/clamp-button/clamp-button'
import cx from 'classnames'

type Props = {
  title: string
  content: string
}

export const ExpandableTextComponent = ({ title, content }: Props) => {
  const { ref, isClamped, isOpen, toggle } = useClampToggle()

  return (
    <section>
      <div className={s.header}>
        <h2 className={s.title}>{title}</h2>
        {isClamped && (
          <span className={s.clampButton}>
            <ClampButton
              isOpen={isOpen}
              onClick={toggle}
              text={isOpen ? 'Show Less' : 'Show More'}
            />
          </span>
        )}
      </div>
      <div
        className={cx(s.content, {
          [s.contentOpen]: isOpen,
        })}
        ref={ref}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </section>
  )
}
